export default "__VITE_ASSET__BTAychjR__"